module.exports = __webpack_public_path__ + "static/media/moonstone-lamp-img2.a0ff9350.jpg";